import { render, staticRenderFns } from "./relatedTicketType.vue?vue&type=template&id=f7e6b86a&scoped=true&"
import script from "./relatedTicketType.vue?vue&type=script&lang=js&"
export * from "./relatedTicketType.vue?vue&type=script&lang=js&"
import style0 from "./relatedTicketType.vue?vue&type=style&index=0&id=f7e6b86a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e6b86a",
  null
  
)

export default component.exports